module.exports = __webpack_public_path__ + "static/html-element-advanced_4-1b90eecbed6ffffc3d0595e1a2fb24fd.jpg";